import { RouteObject } from 'react-router';
import { BlockProvider } from './BlockProvider';
import { Agreement, History, Tasks } from './views';
import { Plan } from '../plan';

export const route: RouteObject = {
  path: 'planning/:block_id/*',
  element: <BlockProvider />,
  children: [
    {
      index: true,
      element: <Plan />,
    },
    {
      path: 'tasks/:task_id?',
      element: <Tasks />,
    },
    {
      path: 'agreement',
      element: <Agreement />,
    },
    {
      path: 'history',
      element: <History />,
    },
  ],
};
